//  Import Swiper React components
import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const Comp = ({
  data,
  slidesPerView = 1,
  renderItem,
  spaceBetween = 50,
  classNameSlide = "",
  autoplay,
  pagination,
  ...props
}: {
  data: any[];
  slidesPerView?: number;
  renderItem: (item?: any) => React.ReactNode;
  spaceBetween?: number;
  classNameSlide?: string;
  autoplay?: boolean | { delay?: number; disableOnInteraction?: boolean };
  pagination?: boolean | { clickable?: boolean };
  [key: string]: any;
}) => {
  const modules = [];
  if (autoplay) modules.push(Autoplay);
  if (pagination) modules.push(Pagination);

  return (
    <Swiper
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      modules={modules}
      autoplay={autoplay}
      pagination={pagination}
      {...props}
    >
      {data.map((item: any, index: number) => (
        <SwiperSlide className={classNameSlide} key={index}>
          {renderItem(item)}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Comp;
